var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    _vm.$style.container,
    {
      [_vm.$style.disabled]: _vm.disabled,
    },
  ]},[_c('label',{class:_vm.$style.label},[(_vm.title)?_c('span',{class:_vm.$style.title},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{class:_vm.$style.content},[_vm._t("default")],2)]),_c('transition',{attrs:{"name":"slide-up-kit","mode":"out-in","appear":""}},[(_vm.error)?_c('div',{key:_vm.error,class:[_vm.$style.error, _vm.isAuthType && _vm.$style.auth]},[_vm._v(" "+_vm._s(_vm.errorToShow)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }